import React, { Suspense } from "react";
import { AuthProvider } from "./Auth";
import { createRoot } from "react-dom/client";
import App from "./components/App/App";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { addLocale } from 'primereact/api';

addLocale('es', {
  firstDayOfWeek: 1,
  dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
  dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
  monthNames: [
    "enero", "febrero", "marzo", "abril", "mayo", "junio",
    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
  ],
  monthNamesShort: [
    "ene", "feb", "mar", "abr", "may", "jun",
    "jul", "ago", "sep", "oct", "nov", "dic"
  ],

  /** 🔥 ESTAS 3 OPCIONES SON LAS QUE TE FALTAN */
  today: 'Hoy',
  clear: 'Limpiar',
  chooseDate: 'Elegir fecha', // <-- ESTA ES LA FALTANTE
});


const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <AuthProvider>
    <Suspense>
      <App />
    </Suspense>
  </AuthProvider>
);
